/* eslint-disable */
import Vue from 'vue'
import RaisePaymentMessage from './index.vue'
import store from '@/store';
const PopupBox = Vue.extend(RaisePaymentMessage)
let instance = null
RaisePaymentMessage.install = function (data) {
  if (data.action === 'close') {
    if (instance) {
      instance.show = false
      store.commit('SET_ORDER_LIST', true)
    }
    return
  }
  instance = new PopupBox({
    data
  }).$mount()
  document.body.appendChild(instance.$el)
  Vue.nextTick(() => {
    instance.show = true
    // show 和弹窗组件里的show对应，用于控制显隐
  })
}
RaisePaymentMessage.close = function () {
  instance.show = false
  store.commit('SET_ORDER_LIST', true)
}
export default RaisePaymentMessage